const NoPermissionsPage = () => {
    // Handle adding the header or normal container contains logout as it's the only option here.
    return <>
    </>
}

export default NoPermissionsPage